module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/neuenburg-a2016b85ebfa69302dae70bf52df8b69.webp";